import { FieldValues, useController, UseControllerProps } from '../FormValidation';
import { ControllerPasswordField, ControllerPasswordFieldProps } from '../ControllerPasswordField';

export function ControllerValidatedPasswordField<TFieldValues extends FieldValues>(
  props: UseControllerProps<TFieldValues> &
    // omit subcomponent properties already controlled by useController
    Omit<
      ControllerPasswordFieldProps,
      'name' | 'value' | 'error' | 'errorText' | 'onChange' | 'onBlur' | 'ref'
    >
) {
  const { name, rules, shouldUnregister, defaultValue, control, ...textFieldProps } = props;

  if (!name) {
    throw new Error('The "name" prop is missing');
  }

  if (!control) {
    throw new Error('The "control" prop is missing');
  }

  const { field, fieldState } = useController({ name, rules, shouldUnregister, defaultValue, control });
  const { ref, ...otherField } = field;
  const { invalid, isDirty, error } = fieldState;

  return (
    <ControllerPasswordField
      {...textFieldProps}
      error={invalid && isDirty}
      errorText={error?.message}
      inputRef={ref}
      {...otherField}
    />
  );
}
